export class Status { 
    constructor(public view: string, public value: string) {
    }	
}